import React from 'react';
import './App.css';
import AboutUs from './components/AboutUs';
import AfterHeader from './components/AfterHeader';
import Experiance from './components/Experiance';
import Footer from './components/Footer';
import FooterMobile from './components/FooterMobile';
import Header from './components/Header';
import InMind from './components/InMind';
import Numbers from './components/Numbers';
import Portfolio from './components/Portfolio';
import Pricing from './components/Pricing';
import Service from './components/Service';
import Testimonial from './components/Testimonial';



function App() {
  return (
    <div className="app">
      <div className="home" id="home">
        <Header />
        <AfterHeader />
        <div className="bg"></div>
      </div>
      <AboutUs />
      <Service />
      <Portfolio />
      <Pricing />
      <Testimonial />
      <Numbers />
      <Experiance />
      <InMind />
      <Footer />
      <FooterMobile />
    </div>
  );
}

export default App;
